'use strict';

/**
 * CompositeView for showing the matching list
 *
 * @category   View
 * @module     import
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCompositeView = require('base/Colido.CompositeView');
var MatchListItemView = require('./match-list-item');

var template = require('../../templates/partials/match-list.hbs');

var MatchListView = ColidoCompositeView.extend({
    template: template,

    childView: MatchListItemView,

    childViewContainer: '.import-match-list-wrapper',

    childViewOptions: function() {
        return {
            fieldsCollection: this.getOption('fieldsCollection'),
            importModel: this.getOption('importModel'),
        };
    },

    childEvents: {
        'fieldmapping:change': 'onChildMappingChange',
    },

    onChildMappingChange: function() {
        this.children.each(function(childView) {
            childView.trigger('update:mapping:selectboxes');
        });
    },
});

module.exports = MatchListView;